import styled from 'styled-components';

import { toRemString, utils } from '@desygner/ui-common-components';

export const StyledWrapperPanel = styled.div<{ open: boolean }>`
  --page-margin: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumSmall)};
  --size-position: 75px;
  transition: transform ${({ theme }) => theme.Transition.Timing.In};
  position: fixed;
  background-color: ${({ theme }) => theme.Components.Panel.Background};
  top: var(--size-position);
  left: 0px;
  bottom: var(--size-position);
  width: ${utils.rem(218)};
  padding: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumSmall)};
  border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.Medium)};
  overflow-y: auto;
  transform: ${({ open }) => (open ? 'translateX(var(--page-margin))' : `translateX(-120%)`)};
  box-shadow: ${toRemString([0, 6, 16, 0])} rgba(0, 0, 0, 0.08),
    ${toRemString([0, 3, 6, -4])} rgba(0, 0, 0, 0.12),
    ${toRemString([0, 9, 28, 8])} rgba(0, 0, 0, 0.05);
  [role='button'] {
    background-color: ${({ theme }) => theme.Color.Neutrals.Dark};
  }
`;
